module.exports = __webpack_public_path__ + "static/media/HCR-RNA-FISH-01.ea732238.png";


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/images/HCR-RNA-FISH-01.png
// module id = 1385
// module chunks = 0